import React from 'react';

import SimpleTableEditable, {
  SimpleTableEditable as InnerSimpleTableEditable,
  SimpleTableEditableProps,
} from 'notebook/simple-tables/SimpleTableEditable';
import {Selector} from 'notebook/tables/excess/Evaluator';
import {Table} from 'notebook/tables/TableConstants';
import {Optional} from 'util/Types';

export type TableWithoutColumnWidths = Omit<Table, 'widths'>;

interface ManageColumnWidthsProps extends Omit<SimpleTableEditableProps, 'table'> {
  initialColumnWidths: Array<number>;
  tableWithoutColumnWidths: TableWithoutColumnWidths;
}

interface State {
  columnWidths: Array<number>;
}

class ManagedColumnsSimpleTableEditable extends React.Component<ManageColumnWidthsProps, State> {
  state: State = {
    columnWidths: this.props.initialColumnWidths,
  };

  static getDerivedStateFromProps(nextProps: ManageColumnWidthsProps, prevState: State): State {
    return {
      columnWidths: nextProps.initialColumnWidths.map((newWidth, i) =>
        prevState.columnWidths[i] ? prevState.columnWidths[i] : newWidth
      ),
    };
  }

  _handleUpdate = (
    index: number,
    {table, selection}: {table: Table; selection: Optional<Array<Selector>>}
  ): void => {
    this.setState({columnWidths: table.widths});
    this.props.updateHandler(index, {table, selection});
  };

  render(): JSX.Element {
    // TODO(BNCH-5877): Make the defaultProps come through the wrapped component
    return (
      <SimpleTableEditable
        {...InnerSimpleTableEditable.defaultProps}
        {...this.props}
        table={{
          ...this.props.tableWithoutColumnWidths,
          widths: this.state.columnWidths,
        }}
        updateHandler={this._handleUpdate}
      />
    );
  }
}

export default ManagedColumnsSimpleTableEditable;
